<template>
  <div>
    <base-header class="pb-6" type="">
      <b-row align-v="center" class="py-4" v-if="1">
        <b-col lg="6" cols="7">
          <h6 class="h2 d-inline-block mb-0">{{language_terms['DASHBOARD']}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4" v-if="0">
            <b-breadcrumb class="breadcrumb-links">
              <b-breadcrumb-item><router-link to="/"><i class="fas fa-home"></i></router-link></b-breadcrumb-item>
              <b-breadcrumb-item><a href="#">{{language_terms['DASHBOARD']}}</a></b-breadcrumb-item>
              <!-- <b-breadcrumb-item active aria-current="page">{{language_terms['DASHBOARD']}}</b-breadcrumb-item> -->
            </b-breadcrumb>
          </nav>
        </b-col>
      </b-row>
      <loading :active="loadingCounter > 0" 
          color= '#007bff'
          :width= '128'
          :height= '128'
          loader='dots'
          :can-cancel="true" 
          :is-full-page="true">
      </loading>
      <b-row v-if="0">
        <b-col xl="3" md="6" v-for="(card, index) in dashboard_summary.cards" :key="index">
          <b-card no-body :class="card.class">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">{{language_terms['APPROVAL_REQUESTS']}}</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{card.stats}}</span>
                  <base-progress class="progress-xs mt-3 mb-0" type="success" :value="30"></base-progress>
                </b-col>
              </b-row>
              <p class="mt-3 mb-0 text-sm">
                <a href="javascript:void(0)" class="text-nowrap text-white font-weight-600" @click="viewDetails(card.details_page_url)">{{language_terms['SEE_DETAILS']}}</a>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
        <b-row>
          <b-col lg="6" md="12">
            <b-card-group deck class="flex-column flex-xl-row">
              <card v-if="dashboard_summary.cards.waybills_summary != null">
                <b-row align-v="center" slot="header">
                  <b-col md="12">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.title}}</h6>
                    <h5 class="h3 mb-0">{{dashboard_summary.cards.waybills_summary.title_sub}}</h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Unfulfilled Waybills (ALL)</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled}}
                      <b-button class="text-nowrap" size="sm" variant="success"
                      v-if="dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled > 0"  
                      @click="onClickDownloadWaybillSummary('waybills_summary_unfulfilled')">
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </b-button>
                    </h2>
                  </b-col>

                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Unfulfilled Waybills (With Sales)</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled_with_orders}}
                      <b-button class="text-nowrap" size="sm" variant="success"
                      v-if="dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled_with_orders > 0" 
                      @click="onClickDownloadWaybillSummary('waybills_summary_unfulfilled_with_orders')">
                      <i class="fa fa-download" aria-hidden="true"></i>
                      </b-button>                    
                    </h2>                  
                  </b-col>                  

                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Unfulfilled Waybills (No Sales)</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled_no_orders}}
                      <b-button class="text-nowrap" size="sm" variant="success"
                      v-if="dashboard_summary.cards.waybills_summary.stats.waybills_unfulfilled_no_orders > 0" 
                      @click="onClickDownloadWaybillSummary('waybills_summary_unfulfilled_no_orders')">
                      <i class="fa fa-download" aria-hidden="true"></i>
                      </b-button>
                    </h2>
                  </b-col>

                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Completed Waybills</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_fulfilled}}</h2>
                  </b-col>

                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Total Uploaded Waybills</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_total}}</h2>
                  </b-col>
                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Not Uploaded Waybills</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{dashboard_summary.cards.waybills_summary.stats.waybills_not_uploaded}}
                      <b-button class="text-nowrap" size="sm" variant="success"
                      v-if="dashboard_summary.cards.waybills_summary.stats.waybills_not_uploaded > 0" 
                      @click="onClickDownloadWaybillSummary('waybills_summary_not_uploaded')">
                      <i class="fa fa-download" aria-hidden="true"></i>
                      </b-button>
                    </h2>
                  </b-col>
                  <b-col md="4" class="mb-3">
                    <h6 class="text-muted ls-1 mb-1">Total Waybills</h6>
                    <h2 class="text-uppercase ls-1 mb-1">{{parseInt(dashboard_summary.cards.waybills_summary.stats.waybills_total) + parseInt(dashboard_summary.cards.waybills_summary.stats.waybills_not_uploaded)}}
                    </h2>
                  </b-col>
                </b-row>

                <b-row class="mt-4">
                  <b-col md="12">
                    <b-button class="text-nowrap" size="md" variant="success"
                      @click="onClickWaybillSummaryUpload()">
                      <i class="fa fa-bin" aria-hidden="true"></i>Upload
                    </b-button>
                    <b-button class="text-nowrap" size="md" variant="danger"
                      @click="onClickWaybillSummaryClearAll()">
                      <i class="fa fa-bin" aria-hidden="true"></i>Clear All
                    </b-button>
                  </b-col>
                </b-row>                        
              </card>      
            </b-card-group>
          </b-col>
        </b-row>
    </b-container>
    <b-modal centered header-bg-variant="light" header-text-variant="" title="Confirmation" v-model="modalConfirmWaybillSummaryPurge" @ok="waybillSummaryPurge()">
        Proceed to clear ALL transactions?
    </b-modal>

  </div>
</template>
<script>
import { mapState } from "vuex";

import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import axios from "axios";

// Charts
import * as chartConfigs from '@/components/Charts/config';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';

// Components
import BaseHeader from '@/components/BaseHeader';
import BaseProgress from '@/components/BaseProgress';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
// import StatsCard from '@/components/Cards/StatsCard';

// Lists
// import ProgressTrackList from './ProgressTrackList';
// import MembersCard from '@/views/Widgets/MembersCard';
// import TaskList from '@/views/Widgets/TaskList';

// Tables
// import quotations from './quotations';
// import VectorMapCard from '@/views/Widgets/VectorMapCard'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
          dashboard_summary: (state) => state.auth.dashboard_summary
        }),
    },
    components: {
      Loading,
      LineChart,
      BarChart,
      BaseHeader,
      BaseProgress,
      RouteBreadCrumb,
      // StatsCard,
      // TaskList,
      // VectorMapCard,
      // quotations,
      // ProgressTrackList,
      // MembersCard
    },
    async mounted()
    {
      // await this.fetchDashboardSummary()
    },
    data() {
        const month = new Date().getMonth();
        const year = new Date().getFullYear();      
        return {
        modalConfirmWaybillSummaryPurge: false,
        loadingCounter:0,
      };
    },
    methods:
    {
      async waybillSummaryPurge()
      {
        let payload = {}
            axios.post(apiRoutes["DBASE_PURGE_TRANSACTIONS"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                  this.fetchDashboardSummary()    
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                } 
            });
      },
      async onClickWaybillSummaryUpload()
      {
        let url = '/sales/upload-documents-hktvm'
        this.$router.push(url)
      },
      async onClickWaybillSummaryClearAll()
      {
        this.modalConfirmWaybillSummaryPurge = true
      },
      async onClickDownloadWaybillSummary(tag)
      {
        this.loadingCounter++
        if (1)
        {
            let apiUrl = apiRoutes['DBASE_DOWNLOAD_FILE']
            await axios.post(apiUrl, {tag: tag}, authHeader(), 
            ).then((response) => {
                const url = URL.createObjectURL(new Blob([response.data], authHeader()))
                const link = document.createElement('a')
                let filename = tag + "_items.txt"

                link.href = url
                link.setAttribute('download',  filename)
                document.body.appendChild(link)
                link.click()
            });
        }
        this.loadingCounter--

      },
      async fetchDashboardSummary()
      {
        this.loadingCounter++
        await this.$store.dispatch("auth/fetchDashboardSummary", {})
        //console.log(this.dashboard_summary)
        this.loadingCounter--

      },
      viewDetails(url)
      {
        this.loadingCounter++
        this.$router.push(url)
        this.loadingCounter--
      }
    }
  };
</script>

<style lang="postcss" scoped>
</style>
<style>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
/* /deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
} */
</style>